'use client';
import {
  Briefcase, Server, Database, Heart, Code, Home, Star, Folder, Globe, Book,
  Cpu, Terminal, Rocket, Lightbulb, Target, Calendar, DollarSign, ShoppingCart,
  Music, Camera, MapPin, Zap, Flag, Bookmark, MessageCircle,
  type LucideIcon,
} from 'lucide-react';

import { DEFAULT_ICON, type MemoryCategoryIcon } from './categoryIconNames';
/** name → lucide component. Lookups go through resolveIcon so unknown/empty falls back to Folder. */
const ICON_MAP: Record<MemoryCategoryIcon, LucideIcon> = {
  Briefcase, Server, Database, Heart, Code, Home, Star, Folder, Globe, Book,
  Cpu, Terminal, Rocket, Lightbulb, Target, Calendar, DollarSign, ShoppingCart,
  Music, Camera, MapPin, Zap, Flag, Bookmark, MessageCircle,
};

/** The lucide component for an allowlist name, or the Folder fallback for anything unknown/empty. */
export function resolveIcon(name: string | null | undefined, fallback: LucideIcon = ICON_MAP[DEFAULT_ICON]): LucideIcon {
  if (name && name in ICON_MAP) return ICON_MAP[name as MemoryCategoryIcon];
  return fallback;
}

/** A category's swatch, trimmed or the shared muted token for a blank stored color. */
export function categorySwatch(color: string | null | undefined): string {
  return (color ?? '').trim() || 'var(--color-muted-foreground)';
}

/** The stored category color as a decorative label dot. */
export function CategoryDot({ color }: { color: string | null | undefined }) {
  return <span aria-hidden className="size-1.5 shrink-0 rounded-full" style={{ backgroundColor: categorySwatch(color) }} />;
}

/** Render a category's icon by allowlist name. Fallback = Folder for unknown/empty. */
export function CategoryIcon({ name, size = 16, className, color }: { name: string | null | undefined; size?: number; className?: string; color?: string | null }) {
  const Icon = resolveIcon(name);
  return <Icon size={size} className={className} style={color === undefined ? undefined : { color: categorySwatch(color) }} aria-hidden />;
}
